import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=e48a9e02&scoped=true&"
import script from "./CustomerView.vue?vue&type=script&lang=js&"
export * from "./CustomerView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/all-admin.css?vue&type=style&index=0&id=e48a9e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a9e02",
  null
  
)

export default component.exports